<template>
  <div>
    <!-- 客户标记 -->
    <el-dialog :title="$t('message.customerMarking')" :close-on-click-modal="false" :visible.sync="dialogVisible"
      width="488px" center>
      <div class="content">
        <div class="row">
          <el-checkbox v-for="(item, index) in list" :key="index" v-model="item.checked" @change="isChage(item)">{{
            item.name }}</el-checkbox>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">

        <!-- 保存 -->
        <el-button type="primary" @click="save">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>

export default {

  data() {
    return {
      dialogVisible: false,
      list: [],
      user_id: this.$route.query.userID,
    };
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible) {
        if (this.$parent.detail.userTag != false) {
          this.list.forEach(item => {
            this.$parent.detail.userTag.forEach(items => {
              if (item.key == items.key) {
                item.checked = true
              } else {
                item.checked = false
              }
            })
          })

        }
      }
    },
  },
  created() {
    this.$api.clienteleApi.tagList().then(res => {
      res.data.forEach(item => {
        // 有无历史
        item.checked = false
      })
      this.list = res.data
    })
  },
  methods: {
    // 保存
    save() {
      this.dialogVisible = false;

    },
    // 添加删除标记
    isChage(item) {
      let datas = {
        user_ids: [this.user_id],
        tag_list: [item],
      }
      if (item.checked) {

        this.$api.clienteleApi.addTag(datas).then(res => {
          this.$message.success(res.msg)
          this.$parent.clientDetail();

        })
      } else {
        this.$api.clienteleApi.deleteTag(datas).then(res => {
          this.$message.success(res.msg)
          this.$parent.clientDetail();
        })
      }

    },
  },
};
</script>
<style lang='scss' scoped>
.content {
  margin: 0px 15px;
  padding: 24px;
  background: #f8f8f8;
  border-radius: 8px;

  p {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 24px;
  }

  .row {
    margin-bottom: 24px;
  }

  /deep/.el-radio__input {
    transform: scale(1.5) !important;
  }
}
</style>